import {
  FETCH_CUSTOMER_DETAIL_DATA_INIT,
  FETCH_CUSTOMER_DETAIL_DATA_SUCCESS,
  FETCH_CUSTOMER_DETAIL_DATA_FAIL,
} from './constants';

const initialState = {
  customerDetailData: null,
  loading: false,
  error: null,
};

const crmCustomerDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_DETAIL_DATA_INIT:
      return { ...state, loading: true, error: null };
    case FETCH_CUSTOMER_DETAIL_DATA_SUCCESS:
      return { ...state, loading: false, customerDetailData: action.payload };
    case FETCH_CUSTOMER_DETAIL_DATA_FAIL:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default crmCustomerDetailReducer;
